import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'

@Component({
  selector: 'app-loading-dialog',
  template: `
    <div class="loading-container">
      <mat-spinner diameter="48"></mat-spinner>
      <p>{{ data.mensagem }}</p>
    </div>
  `,
  styles: [`
    .loading-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
      padding: 32px 48px;
    }
    p {
      margin: 0;
      font-size: 14px;
      color: #555;
    }
  `]
})
export class LoadingDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { mensagem: string }) {}
}
